<div class="os-panel">
  <p class="os-empty" *ngIf="!customerId">
    Salve o cliente para listar as ordens de serviço.
  </p>

  <ng-container *ngIf="customerId">
    <p class="os-empty" *ngIf="loading">Carregando ordens de serviço...</p>
    <p class="os-empty" *ngIf="!loading && rows.length === 0">
      Nenhuma OS encontrada para este cliente.
    </p>

    <table mat-table [dataSource]="rows" *ngIf="!loading && rows.length" class="os-table">
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>OS</th>
        <td mat-cell *matCellDef="let row">{{ row.code }}</td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>TÍTULO</th>
        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>TIPO</th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>STATUS</th>
        <td mat-cell *matCellDef="let row">{{ row.status }}</td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>CRIADO EM</th>
        <td mat-cell *matCellDef="let row">{{ row.createdAt }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="open(row)"></tr>
    </table>
  </ng-container>
</div>
